import styled from 'styled-components';

const Hr = styled.hr`
  width: 100%;
  border: 0.5px solid ${props => props.theme.colors.grey};
  margin: 20px 0;
`;

export default Hr;
